module.exports = __webpack_public_path__ + "img/developer.ed02891e.svg";